import "antd/dist/antd.min.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import { AppProvider } from "./State/Global/AppContext";
import "./Styles/WebGlobal.scss";
import WebWrapper from "./Views/WebWrapper/WebWrapper";
import { createRoot } from "react-dom/client";

//import registerServiceWorker from "./serviceWorkerRegistration";

//registerServiceWorker();

const rootElement = document.getElementById("opt-agent");

const renderApp = () => (
    <React.StrictMode>
        <AppProvider>
            <WebWrapper>
                <BrowserRouter>
                    <Routes>
                        <Route path="*" element={<App />} />
                    </Routes>
                </BrowserRouter>
            </WebWrapper>
        </AppProvider>
    </React.StrictMode>
);

// Use createRoot API to render the app
const root = createRoot(rootElement);
root.render(renderApp());
